import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import { classNames } from '../../utils/tailwind/classNames';

interface RecommendationsSkeletonProps {
    isDrawer?: boolean;
}

export const RecommendationsSkeleton: FC<RecommendationsSkeletonProps> = ({ isDrawer }) => (
    <div
        className={classNames('flex w-full flex-col bg-white', {
            'gap-5 pb-8 pt-1': isDrawer,
            'gap-6 py-4': !isDrawer,
        })}
        data-testid="recommendation-skeleton"
    >
        <Skeleton
            className={classNames('w-[300px] max-w-full', {
                'h-7': isDrawer,
                'h-8': !isDrawer,
            })}
        />
        <Skeleton
            className={classNames('w-full', {
                'h-[146px] md:h-[154px]': isDrawer,
                'h-[320px]': !isDrawer,
            })}
        />
    </div>
);

RecommendationsSkeleton.defaultProps = {
    isDrawer: false,
};
